module.exports = __webpack_public_path__ + "static/booksGif-ce01637e09b67dd5baf368a4cb8f3411.gif";